//对axios进行二次封装
import axios from "axios";

//利用axios对象的方法create创建一个axios实例
//下面的requests就是axios实例对象
const requests=axios.create({
    //基础路径，发送请求时默认会加上
    //baseURL:"https://www.jincheng.website/api/api",
    //超时时间
    timeout:5000,
});

//请求拦截器：发请求之前做的事
requests.interceptors.request.use((config)=>{
    //config:配置对象，里面有一个很重要的属性headers（请求头）
    return config;
});

//响应拦截器：可以在成功和失败的回调中写事情
requests.interceptors.response.use((res)=>{
    //成功的回调：服务器响应数据回来以后可以检测到，可以做一些事
    console.log("resp");
    return res.data;
},(error)=>{
    console.log("error111",error);
    //失败的回调：服务器响应失败时可以做一些事
    //return Promise.reject(new Error("false"));//终止Promise链
});

//对外暴露axios对象
export default requests;